class megaMenu extends HTMLElement {
  constructor() {
    super();
    const megaMenu2 = this;
    let timeout;
    let isOpen = false;
    const debounce = (func, wait) => {
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    };
    const showMenu = () => {
      megaMenu2.classList.remove("js-hidden");
      isOpen = true;
    };
    const hideMenu = () => {
      megaMenu2.classList.add("js-hidden");
      isOpen = false;
    };
    const toggleMenu = () => {
      if (isOpen) {
        hideMenu();
      } else {
        showMenu();
      }
    };
    const debouncedShow = debounce(showMenu, 100);
    const debouncedHide = debounce(hideMenu, 200);
    const mobileMenuTrigger = document.querySelector("#js-trigger-mobile-menu");
    const mobileNavigation = document.querySelector(".mobile-navigation");
    if (mobileMenuTrigger && mobileNavigation) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes" && mutation.attributeName === "class") {
            if (!mobileNavigation.classList.contains("js-mobile-navigation-open")) {
              hideMenu();
            }
          }
        });
      });
      observer.observe(mobileNavigation, {
        attributes: true
      });
    }
    const headerNavigationItem = document.querySelectorAll(
      `#header-navigation-item-${this.dataset.megaMenuHandle}`
    );
    if (headerNavigationItem.length > 0) {
      headerNavigationItem.forEach((item) => {
        if (item.hasAttribute("data-mega-menu-trigger")) {
          item.addEventListener("click", (e) => {
            e.preventDefault();
            if (item.hasAttribute("data-mega-menu-close-trigger")) {
              toggleMenu();
            } else {
              showMenu();
              megaMenu2.addEventListener("mouseleave", window.innerWidth > 768 ? debouncedHide : null);
            }
          });
        } else {
          item.addEventListener("mouseover", debouncedShow);
          item.addEventListener("mouseleave", window.innerWidth > 768 ? debouncedHide : null);
        }
      });
    }
    const backContainer = this.querySelector(".js-back-container");
    if (backContainer) {
      backContainer.addEventListener("click", hideMenu);
    }
    const hasTrigger = headerNavigationItem.length > 0 && headerNavigationItem[0].hasAttribute("data-mega-menu-trigger");
    if (!hasTrigger) {
      megaMenu2.addEventListener("mouseover", window.innerWidth > 768 ? debouncedShow : null);
      megaMenu2.addEventListener("mouseleave", window.innerWidth > 768 ? debouncedHide : null);
    }
    this._isOpen = isOpen;
    document.querySelectorAll('[id^="header-navigation-item-"]').forEach((navItem) => {
      if (!navItem.id.endsWith(this.dataset.megaMenuHandle)) {
        navItem.addEventListener("click", () => {
          if (isOpen) {
            hideMenu();
          }
        });
      }
    });
  }
}
if (customElements.get("mega-menu") === void 0) {
  customElements.define("mega-menu", megaMenu);
}
